<template>
    <div role="main" class="main contact">
        <div v-if="ready==false" class="loader">
            <div class="container">
                <div class="row">
                    <div class="col-sm-1 mx-md-auto text-center">
                        <spring-spinner
                        :animation-duration="3000"
                        :size="60"
                        color="#124191"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="container">
                <div class="row">
                    <div class="col-sm-12 mx-md-auto text-uppercase text-center">
                        <h2 class="font-weight-normal text-9 mb-3 pb-5 pt-5">Contact us</h2>    
                    </div>
                </div>
                <div class="row pb-5">
                    <div class="col-sm-12 mx-md-auto text-center" v-html="content"></div>
                </div>
            </div>
            <Team />
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { SpringSpinner  } from 'epic-spinners'
import Team from '@/components/Team.vue'

export default {
    name: 'Contact',
    components: {
        Team
    },
    data(){
        return{
            email: 'kontakt@codedive.pl',
            phone: '518418603',
            content: '',
            ready: false,
        }
    },
    methods: {
        getConent(){
            axios.get(process.env.VUE_APP_BASE_URL+'/codedive/items/contact')
                .then(response => {
                    this.content = response.data.data[0].content;
                })
                .then(response => {
                    this.ready = true;
                })
                
        },
    },
    created(){
        this.getConent();
    },
}
</script>

<style lang="scss">
    @import '@/assets/sass/variables.scss';

    .contact{
        a{
            color: $black;
        }
    }
</style>